import React from "react"
import Link from "../component/link"
import styled from "styled-components"
import logo from "../../assets/images/logo_claus_white.svg"
import twitter from "../../assets/images/logo_twitter.svg"
import facebook from "../../assets/images/logo_facebook.svg"
import youtube from "../../assets/images/logo_youtube.svg"
import instagram from "../../assets/images/logo_linkedin.svg" // Using linkedin image for instagram
import linkedin from "../../assets/images/logo_linkedin.svg"
import phone from "../../assets/images/phone.svg"

import { ARRAY_LINKS } from "../header/includes/menuMeans"

const Footer = styled.footer`
  background: #191851;
  color: white;
  font-size: 1rem;
  li a {
    cursor: pointer;
  }
  ul {
    color: white;
    padding: 0;
    font-size: 16px;
    & > li {
      list-style: none;
      a,
      a:hover {
        color: #d0dcf0;
        font-size: 14px;
        font-weight: normal;
        text-decoration: none;
      }
    }
  }
  p {
    margin: 0 5px;
  }
  .container-telephone {
    font-size: 12px;
  }
  .telephone-title {
    font-size: 16px;
    color: #ffffffb3;
  }
  .title-country {
    font-size: 1rem;
  }
  .title-term-condition {
    font-size: 12px;
    color: #b1c5e7;
  }
  .title-copy-right {
    color: white;
    font-size: 11px;
  }
  .phone {
    margin: 5px 20px 0 0;
  }
`

let SocialLink = ({ Icon, to, platform }) => (
  <a href={to} target="_blank" rel="noopener noreferrer" className="mr-2">
    <img src={Icon} alt={`Claus software contable y facturación electrónica en ${platform || 'redes sociales'}`} loading="lazy" />
  </a>
)

const ARRAY_PLANS = [
  {
    title: "contador",
    link: "contador",
  },
  {
    title: "empresario",
    link: "empresa",
  },
  {
    title: "facturación electrónica",
    link: "electronica",
  },
]

const Foot = currentLocation => {
  const PRODUCTOS_SOFTWARE = [
    {
      action: "nomina",
      name: "Nómina",
    },
    {
      action: "pos",
      name: "POS (punto de venta)",
    },
    {
      action: "financiera",
      name: "Indicadores financieros",
    },
    {
      action: "adicional",
      name: "Usuario adicional",
    },
    {
      action: "inventarios",
      name: "Bodegas (control de inventarios)",
    },
    {
      action: "facturacion",
      name: "Facturación en bloque",
    },
    {
      action: "automatico",
      name: "Inventarios automáticos",
    },
    {
      action: "produccion",
      name: "Producción",
    },
    {
      action: "ventas",
      name: "Fuerza de ventas",
    },
  ]

  return (
    <Footer className="pt-10 sm:mt-10">
      <div className="max-w-screen-2xl m-auto flex flex-wrap justify-center">
        <div className="p-5 w-1/2 sm:w-4/12 md:w-2/12">
          <h5>
            <SocialLink Icon={logo} to="/" platform="sitio oficial" />
          </h5>
          <ul>
            <li>
              <Link to="/" className="my-10 block">
                <img
                  className="phone"
                  align="left"
                  src={phone}
                  alt="Teléfono de contacto Claus - Software contable y facturación electrónica"
                  loading="lazy"
                />
                {/* <p className="container-telephone">Telefono</p>
                <span className="telephone-title">+57 349 345 4678</span> */}
              </Link>
            </li>
            <li className="my-16">
              <div className="flex">
                <SocialLink
                  to="https://twitter.com/clausco_co"
                  className="flex-1"
                  Icon={twitter}
                  platform="Twitter"
                />
                <SocialLink
                  to="https://web.facebook.com/Clausoficialco"
                  className="flex-1"
                  Icon={facebook}
                  platform="Facebook"
                />
                <SocialLink
                  to="https://www.youtube.com/@Clauserp"
                  className="flex-1"
                  Icon={youtube}
                  platform="YouTube"
                />
                <SocialLink
                  to="https://www.instagram.com/claus_co/"
                  className="flex-1"
                  Icon={instagram}
                  platform="Instagram"
                />
                <SocialLink
                  to="https://www.linkedin.com/company/claus-co/"
                  className="flex-1"
                  Icon={linkedin}
                  platform="LinkedIn"
                />
              </div>
            </li>
          </ul>
        </div>

        <div className="p-5 w-1/2 sm:w-4/12 md:w-2/12">
          <div className="text-base font-medium">Productos</div>
          <ul>
            {PRODUCTOS_SOFTWARE &&
              PRODUCTOS_SOFTWARE.map(({ action, name }, i) => {
                return (
                  <li key={i} className="my-3">
                    <Link
                      to={`/aplicaciones#${action}`}
                      className="block text-sm text-gray-300"
                    >
                      {name}
                    </Link>
                  </li>
                )
              })}
          </ul>
        </div>

        <div className="p-5 w-1/2 sm:w-4/12 md:w-2/12">
          <div className="text-base font-medium">Planes</div>
          <ul>
            <li className="my-3">
              <Link to="/" className="block text-sm text-gray-300">
                Software contable
              </Link>
            </li>
            {ARRAY_PLANS &&
              ARRAY_PLANS.map(({ title, link }, i) => {
                return (
                  <li key={i} className="my-3">
                    <Link
                      to={`/producto?${link}`}
                      className="block text-sm text-gray-300"
                    >
                      {title}
                    </Link>
                  </li>
                )
              })}
          </ul>
        </div>

        <div className="p-5 w-1/2 sm:w-4/12 md:w-2/12">
          <div className="text-base font-medium">Recursos</div>
          <ul>
            {ARRAY_LINKS &&
              ARRAY_LINKS.map(({ name, url }, i) => (
                <li key={i} className="my-3">
                  <Link
                    to={url}
                    className="block text-sm text-gray-300"
                  >
                    {name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        <div className="w-full pt-2 border-t border-blue-800">
          <div className="container flex pb-5 px-3 m-auto pt-5 text-sm flex-col md:flex-row max-w-6xl">
            <div className="flex">
              <span className="title-country">Colombia</span>
            </div>
            <div className="md:flex-auto md:flex-row-reverse mt-2 flex-row flex"></div>
            <div className="title-copy-right">
              © Clauserp. Todos los Derechos Reservados
            </div>
          </div>
        </div>
      </div>
    </Footer>
  )
}

export default Foot
